import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import SelectCustomerServiceRender from './render'

const SALES_QUERY = gql`
  query CustomerServices($limit: Int) {
    customerServices(limit: $limit) {
      id
      fullName
    }
  }
`

const SelectCustomerService = ({
  defaultValue,
  fullWidth,
  onChange,
  outerLoading,
  value
}) => {
  const initValueRef = useRef(false)
  const [selected, setSelected] = useState(undefined)
  const { loading: innerLoading, data, error } = useQuery(SALES_QUERY, { variables: { limit: -1 } })

  useEffect(() => { initialValue() }, [defaultValue])
  useEffect(() => { updateValue() }, [value])

  if (error) { console.error(error) }

  const initialValue = () => {
    if (initValueRef.current || outerLoading || selected) return null

    initValueRef.current = true
    handleChange(defaultValue)
  }

  const updateValue = () => {
    if (value === selected) return null

    handleChange(value)
  }

  const handleChange = value => {
    setSelected(value)
    onChange(value)
  }

  return (
    <SelectCustomerServiceRender
      fullWidth={fullWidth}
      items={data && data.customerServices}
      loading={outerLoading || innerLoading}
      onChange={handleChange}
      selected={selected}
    />
  )
}

SelectCustomerService.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func,
  outerLoading: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SelectCustomerService.defaultProps = {
  fullWidth: false,
  onChange: () => {}
}

export default SelectCustomerService
